const apiUrl = process.env.REACT_APP_API_URL;

export async function PostClaimReward(idActivitat: string, idProblema: string, userId: string, caughtJavamonId?: string, previewJavamonId?: string, esPractica?: boolean, selectedRewardId?: number | null, origenTipo?: string, force?: boolean) {
    const url = `${apiUrl}:8061/jutge/activitats/${idActivitat}/problemes/${idProblema}/claim-reward`;
    try {
        const payload: any = {
            id_usuari: userId
        };
        if (force) {
            payload.force = true;
        }
        if (caughtJavamonId) {
            payload.caughtJavamonId = caughtJavamonId;
        }
        if (previewJavamonId) {
            payload.previewJavamonId = previewJavamonId;
        }
        if (esPractica !== undefined) {
            payload.esPractica = esPractica;
        }
        if (selectedRewardId !== undefined && selectedRewardId !== null) {
            payload.selectedRewardId = selectedRewardId;
        }
        if (origenTipo) {
            payload.origen_tipo = origenTipo;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken') || localStorage.getItem('token') || ''}`
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            let errorMsg = 'No se pudo reclamar la recompensa';
            try {
                const errData = await response.json();
                errorMsg = errData.message || errData.missatge || errData.error || errorMsg;
            } catch (_) {
                try {
                    const text = await response.text();
                    if (text) errorMsg = text;
                } catch (__) {}
            }
            return { status: 'error', message: errorMsg };
        }
        return await response.json();
    } catch (e) {
        return { status: 'error', message: 'Error de red' };
    }
}
